// client/src/components/layout/NavItem.jsx
import { NavLink } from 'react-router-dom';

export default function NavItem({
  to,
  exact = false,
  label,
  icon: Icon,
  collapsed = false,
  onNavigate,
}) {
  const getClassName = ({ isActive }) => {
    const base =
      'group relative flex w-full items-center gap-3 rounded-xl px-3 py-2 text-sm font-medium text-slate-200 ' +
      'transition-colors motion-safe:duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/60 ' +
      'focus-visible:ring-offset-0 hover:bg-white/5 hover:text-white';
    const collapsedClasses = collapsed ? ' justify-center px-0' : '';
    const activeClasses = isActive
      ? ' text-white bg-gradient-to-r from-white/10 via-amber-400/10 to-transparent shadow-[0_16px_40px_-18px_rgba(246,196,82,0.9)] ring-1 ring-amber-300/25 before:absolute before:left-0 before:top-1 before:bottom-1 before:w-1.5 before:rounded-full before:bg-gradient-to-b before:from-amber-300 before:to-teal-300'
      : '';
    return base + collapsedClasses + activeClasses;
  };

  return (
    <NavLink
      to={to}
      end={exact}
      onClick={onNavigate}
      className={getClassName}
      title={collapsed ? label : undefined}
      aria-label={collapsed ? label : undefined}
    >
      <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl border border-white/10 bg-white/5 text-slate-200 shadow-[0_12px_28px_-16px_rgba(246,196,82,0.7)] group-hover:text-white group-[.active]:border-amber-400/60 group-[.active]:bg-amber-400/10">
        <Icon className="h-5 w-5" />
      </span>
      {!collapsed && <span className="truncate">{label}</span>}
    </NavLink>
  );
}
